import {Component, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {AnimationItem} from 'lottie-web';
import {AnimationOptions, LottieComponent} from 'ngx-lottie';
import {SUBSCRIPTIONS} from '../../common/utils/constants';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {PageTitleService} from '../../services/page-title.service';
import {AutoUnsubscribe} from '../../decorators/auto-unsubscribe.decorator';
import {ToastrMessagesProvider} from '../../services/toastr-messages.service';
import {ToastContainerDirective} from 'ngx-toastr';
import {AuthService} from '../shared/services/auth.service';
import {NgClass, NgOptimizedImage} from '@angular/common';
import {FooterComponent} from '../shared/components/footer/footer.component';

declare global {
  interface Window {
    UserWay: any;
    dataLayer: any;
  }
}

@Component({
  standalone: true,
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  imports: [NgClass, ToastContainerDirective, NgOptimizedImage, RouterOutlet, LottieComponent, FooterComponent],
})
@AutoUnsubscribe()
export class AuthLayoutComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  private pageTitleService = inject(PageTitleService);
  private router = inject(Router);
  private toastrMessagesProvider = inject(ToastrMessagesProvider);

  @ViewChild(ToastContainerDirective, {static: true})
  toastContainer: ToastContainerDirective;
  html = null;
  widgetPreloaded = false;

  options: AnimationOptions = {
    path: './assets/lottie/widget-anim.json',
  };
  animationCreated(animationItem: AnimationItem): void {}

  ngOnInit(): void {
    this.toastrMessagesProvider.commonMessageContainer = this.toastContainer;
    this.html = document.getElementsByTagName('html');
    this.html[0].classList.add('login-page');
    this.pageTitleService.setPageTitle(this.router.url);
    this[SUBSCRIPTIONS].add(
      this.router.events
        .pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.pageTitleService.setPageTitle(event.url);
        }),
    );
  }

  openWidget(): void {
    if (window.UserWay) {
      window.UserWay.widgetOpen();
    }
  }

  preloadWidget(): void {
    if (!this.widgetPreloaded && window.UserWay) {
      this.widgetPreloaded = true;
      window.UserWay.preloadWidget();
    }
  }

  ngOnDestroy(): void {
    this.html?.[0].classList.remove('login-page');
  }
}
